import { fade } from '@material-ui/core/styles/colorManipulator';
const drawerWidth = 300;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  textFail: {
    color: '#ff0000',
    fontSize: '0.75rem'
  },
  verticalDivider: {
    width: 1,
    height: 20,
    margin: 4
  },
  logoOpen: {
    padding: theme.spacing.unit,
    height: 64
  },
  logoClose: {
    width: '100%',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  popper: {
    zIndex: theme.zIndex.drawer,
    position: 'absolute'
  },
  datePicker: {
    display: 'flex',
    top: '10px',
    zIndex: theme.zIndex.drawer,
    position: 'absolute',
    right: '5%'
  },
  rightSidebarDrawerWrapperRoot: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%'
  },
  mapActions: {
    top: '10px',
    zIndex: theme.zIndex.drawer,
    position: 'absolute',
    left: '125%',
    display: 'flex',
    paddingRight: theme.spacing.unit * 0.5,
    paddingLeft: theme.spacing.unit * 0.5
  },
  mapActionsDrawerClose: {
    left: '150%',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  toggleDrawerState: {
    cursor: 'pointer',
    top: 10,
    zIndex: theme.zIndex.drawer + 1,
    position: 'absolute',
    left: '100%',
    width: 15,
    height: 35
  },
  toggleDrawerIcon: {
    cursor: 'hand',
    position: 'absolute',
    left: '50%',
    top: 21,
    transform: 'translate(-50%, -50%)'
  },
  date: {
    height: 80,
    width: 200
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  agentInfo: {
    width: 130
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    position: 'relative'
  },
  drawerWrapperOpen: {
    position: 'relative',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerWrapperClose: {
    position: 'relative',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9 + 1
    }
  },
  topBarOpen: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    zIndex: theme.zIndex.drawer + 1,
    top: 0,
    position: 'fixed',
    height: 64,
    width: drawerWidth,
    overflow: 'hidden',
    backgroundColor: theme.palette.primary.main
  },
  topBarClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    alignItems: 'center',
    display: 'flex',
    zIndex: theme.zIndex.drawer + 1,
    top: 0,
    position: 'fixed',
    height: 64,
    backgroundColor: theme.palette.primary.main,
    overflow: 'hidden',
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9 + 1
    }
  },
  drawerOpen: {
    width: drawerWidth,
    //overflow: 'auto',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  typography: {
    padding: theme.spacing.unit
  },
  rightsidebarText: {
    fontSize: '0.75rem'
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4
  },

  radiusSearch: {
    paddingLeft: theme.spacing.unit * 10
  },

  drawerExpandLessIcon: {
    position: 'fixed',
    bottom: 0,
    height: 70,
    background: 'white',
    zIndex: theme.zIndex.drawer + 1,
    width: drawerWidth,
    overflow: 'hidden',
    borderTop: `1px solid ${theme.palette.divider}`,
    borderRight: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },

  drawerExpandMoreIcon: {
    position: 'fixed',
    top: 64,
    height: 70,
    background: 'white',
    zIndex: theme.zIndex.drawer,
    width: drawerWidth,
    overflow: 'hidden',
    borderTop: `1px solid ${theme.palette.divider}`,
    borderRight: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },

  zeroMargin: {
    margin: 0
  },

  justifyCenter: {
    justifyContent: 'center'
  },

  scrollableDiv: {
    height: '75vh',
    overflow: 'auto'
  },

  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9 + 1
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },

  drawerContainer: {
    height: '75vh',
    overflow: 'auto'
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit,
      width: 'auto'
    }
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cashInIcon: {
    fontSize: '0.9rem',
    color: 'green',
    textAlign: 'center'
  },
  withdrawIcon: {
    fontSize: '0.9rem',
    color: 'red',
    textAlign: 'center'
  },
  cashIcon: {
    fontSize: 'inherit',
    textAlign: 'center'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200
      }
    }
  }
});

export default styles;
